/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _5 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>5 - Процесс работы с Git-проектом</h2>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Для нового проекта создается удаленный репозиторий и клонируется на локальную машину. У вас появляется точная
        копия удаленного репозитория, которая автоматически с ним связывается. Или создается локальная папка с проектом,
        после чего она связывается с удаленным репозиторием.
      </li>
      <li className={styles.list__item}>Далее идет работа в мастере или в ветках.</li>
      <li className={styles.list__item}>Вы изменяете файлы в вашей рабочей директории.</li>
      <li className={styles.list__item}>
        Вы добавляете файлы в индекс, добавляя тем самым их снимки в область подготовленных файлов.
      </li>
      <li className={styles.list__item}>
        Когда вы делаете коммит, используются файлы из индекса как есть, и этот снимок сохраняется в вашу
        Git-директорию.
      </li>
      <li className={styles.list__item}>
        Если вы работаете сами, в ветке, то перед тем как делать пуш необходимо смерджить ветку в локальный мастер. Если
        же разработчиков много, процесс работы с ветками несколько усложняется.
      </li>
      <li className={styles.list__item}>Делается пуш для обновления удаленного репозитория.</li>
    </ul>
  </section>
))
